const MemoryRouteNavigationOptions = {
  title: 'Memory',
  headerTitle: 'Memory',
  headerBackVisible: false,
};

export default MemoryRouteNavigationOptions;
